import { render, staticRenderFns } from "./ConsultOrganization.vue?vue&type=template&id=47dd7e34&scoped=true"
import script from "./ConsultOrganization.vue?vue&type=script&lang=js"
export * from "./ConsultOrganization.vue?vue&type=script&lang=js"
import style0 from "./ConsultOrganization.vue?vue&type=style&index=0&id=47dd7e34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47dd7e34",
  null
  
)

export default component.exports